import { Navigate, useLocation } from 'react-router-dom';
import { useAppSelector } from 'store/index';
import { selectIsSeller } from 'store/selectors/me/company';
import { selectIsSuperUser } from 'store/selectors/me/user';
import { SettingsSubLayout } from 'containers/SettingsPage/SettingsLayout';

enum SectionSegments {
  Brand = 'brand',
  SocialLinks = 'social',
  Attributes = 'attributes',
  Assets = 'assets',
  Shipping = 'shipping',
  ServiceOptions = 'service-options',
}

const MarketplaceTab = () => {
  const { pathname } = useLocation();
  const section = pathname.split('/')[3] as SectionSegments | undefined;
  const isSeller = useAppSelector(selectIsSeller);
  const isSuperUser = useAppSelector(selectIsSuperUser);

  if (!isSeller || !isSuperUser) {
    return <Navigate to="/settings/preferences/account" replace />;
  }

  const selectedSection =
    section && Object.values(SectionSegments).includes(section) ? section : SectionSegments.Brand;

  return (
    <SettingsSubLayout
      items={[
        {
          label: 'Brand',
          iconName: 'info',
          to: '/settings/marketplace/brand',
          isActive: selectedSection === SectionSegments.Brand,
        },
        {
          label: 'Social Links',
          iconName: 'globe',
          to: '/settings/marketplace/social',
          isActive: selectedSection === SectionSegments.SocialLinks,
        },
        {
          label: 'Attributes',
          iconName: 'shapes',
          to: '/settings/marketplace/attributes',
          isActive: selectedSection === SectionSegments.Attributes,
        },
        {
          label: 'Assets',
          iconName: 'image',
          to: '/settings/marketplace/assets',
          isActive: selectedSection === SectionSegments.Assets,
        },
        {
          label: 'Shipping',
          iconName: 'truck',
          to: '/settings/marketplace/shipping',
          isActive: selectedSection === SectionSegments.Shipping,
        },
        {
          label: 'Service Options',
          iconName: 'settings',
          to: '/settings/marketplace/service-options',
          isActive: selectedSection === SectionSegments.ServiceOptions,
        },
      ]}
    />
  );
};

export default MarketplaceTab;
